import React from 'react';
import { NewTypography as Typography, RoundButton } from '@lamimed/pantheon';

import { useSubmit } from '../useSubmit';

import { useGetFields } from './useGetFields';

import * as S from './styles';

type GetInTouchFormProps = {
  formHandler: ReturnType<typeof useSubmit>;
};

export const RequestDemoForm: React.FC<GetInTouchFormProps> = ({
  formHandler,
}) => {
  const fields = useGetFields(formHandler);
  const { handleSubmit, loading, onSubmit, errors } = formHandler;

  return (
    <>
      <Typography variant="heading_3" marginBottom="small">
        Richiedi una demo
      </Typography>

      <Typography variant="body_text_2" marginBottom="medium">
        Per scoprire come Lami può aiutare la tua azienda, lasciaci i tuoi
        riferimenti e ti ricontatteremo.
      </Typography>

      <S.Form id="request-demo" onSubmit={handleSubmit(onSubmit)}>
        <S.FieldGroup marginBottom="none">
          <S.FieldRow error={!!errors.company_name}>
            {fields.company_name}
          </S.FieldRow>

          <S.FieldRow error={!!errors.name || !!errors.surname}>
            {fields.name}

            {fields.surname}
          </S.FieldRow>

          <S.FieldRow error={!!errors.phone}>{fields.phone}</S.FieldRow>

          <S.FieldRow error={!!errors.email}>{fields.email}</S.FieldRow>

          <S.FieldRow error={!!errors.message}>{fields.message}</S.FieldRow>
        </S.FieldGroup>

        <RoundButton
          disabled={loading}
          expanded
          type="submit"
          loading={loading}
        >
          Invia
        </RoundButton>
      </S.Form>
    </>
  );
};
